module.exports = __webpack_public_path__ + "42b8dae4dce6a389365426235fd1f3d9.svg";